webpackJsonp([3,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(218);
	module.exports = __webpack_require__(217);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ },

/***/ 2:
/***/ function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ },

/***/ 4:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 217:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	if (language == 'zh-CN') {
	    $('body').removeClass('en');
	} else {
	    $('body').addClass('en');
	}
	// if(language=='zh-CN'|| language=='USA'){
	// }else{
	//     $('.joinUs_hotelPic_thumb_arula').hide()
	//     $('.no-args').hide()
	// }
	var Config = __webpack_require__(1);
	var url_prefix = Config.env[Config.scheme].prefix;
	var riyuMap = __webpack_require__(242);
	var hanyuMap = __webpack_require__(241);
	var taiyuMap = __webpack_require__(243);
	var yueyuMap = __webpack_require__(244);
	if (language == 'JP') {
	    $('.map_en').attr('src', riyuMap);
	} else if (language == 'KO') {
	    $('.map_en').attr('src', hanyuMap);
	} else if (language == 'TH') {
	    $('.map_en').attr('src', taiyuMap);
	} else if (language == 'YH') {
	    $('.map_en').attr('src', yueyuMap);
	}
	$('.commonJoinInCooperation').addClass('select');
	$('.reservation').css('color', 'white');
	
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	var width = document.documentElement.clientWidth;
	
	$(window).resize(function () {
	    //当浏览器大小变化时
	    width = document.documentElement.clientWidth;
	});
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    console.log(window.location);
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	    //window.location.reload();
	});
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	$('.submitInfo_input_1').on('click', function () {
	    $('.select_forJoinUs').slideToggle();
	});
	$('.select_forJoinUs span').on('click', function () {
	    $('.submitInfo_input_joinUs').html($(this).html());
	});
	$('body').on('click', function (e) {
	    if (e.target.className != "submitInfo_input_joinUs homePageSwiperFiveJoin" && e.target.className != "submitInfo_input submitInfo_input_1") {
	        $('.select_forJoinUs').slideUp();
	    }
	});
	$(".submitInfo_submit").on("click", submitInfo);
	function submitInfo() {
	    if (!$(".submitInfo_name").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputName[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    // 判断国外手机号不能为空
	    if ($(".submitInfo_phone").val() == '') {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    // 只有中国走手机号判断
	    if (language == 'zh-CN') {
	        if (!/^1[34578]\d{9}$/.test($(".submitInfo_phone").val())) {
	            $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
	            $(".submitInfo_submit").off("click", submitInfo);
	            $(".submitInfo_tips_1").show();
	            setTimeout(function () {
	                $(".submitInfo_tips_1").hide();
	                $(".submitInfo_submit").on("click", submitInfo);
	            }, 1500);
	            return;
	        }
	    }
	
	    if ($(".submitInfo_name").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputNameLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if ($(".submitInfo_address").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!$(".submitInfo_address").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    sensors.track("formSubmit", { "name": $('.submitInfo_name').val(), 'phone_number': $(".submitInfo_phone").val(), 'address': $(".submitInfo_address").val(), 'form_entrance': 'PC加盟页'
	    });
	    $(".submitInfo_submit").off("click", submitInfo);
	
	    $.ajax({
	        url: url_prefix + '/mng/api/pcms/league/create.json',
	        type: 'POST',
	        data: {
	            name: $(".submitInfo_name").val(),
	            mobile: $(".submitInfo_phone").val(),
	            address: $(".submitInfo_address").val(),
	            dataSource: parseInt(GetQueryString('source')) ? parseInt(GetQueryString('source')) : 1
	        },
	        dataType: 'json',
	        timeout: 5000,
	        success: function (res) {
	            if (res.success) {
	                //埋点信息
	                _agtjs('loadEvent', { atsev: 101, 'atsusr': $(".submitInfo_name").val(), 'atsykc': $(".submitInfo_phone").val() });
	
	                $(".submitInfo_tips_1").html(commonCompanyCubmitSuccess[language]);
	                $(".submitInfo_tips_1").show();
	                $(".submitInfo_name").val("");
	                $(".submitInfo_phone").val("");
	                $(".submitInfo_address").val("");
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            } else {
	                $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	                $(".submitInfo_tips_1").show();
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            }
	        },
	        error: function (error) {
	            $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	            $(".submitInfo_tips_1").show();
	            setTimeout(function () {
	                $(".submitInfo_tips_1").hide();
	                $(".submitInfo_submit").on("click", submitInfo);
	            }, 1500);
	            $(".submitInfo_submit").on("click", submitInfo);
	        }
	    });
	}
	$("img").on('dragstart', function () {
	    return false;
	});
	
	function placeholderSupport() {
	    return 'placeholder' in document.createElement('input');
	}
	
	function placeholder(target) {
	
	    $(target).val($(target).attr("datavalue")).addClass("inp");
	    $(target).focus(function () {
	        if ($(this).val() == $(this).attr("datavalue")) {
	            $(this).val("").removeClass("inp");
	        }
	    });
	    $(target).blur(function () {
	        if ($(this).val() == "" || $(this).val() == $(this).attr("datavalue")) {
	            $(this).val($(target).attr("datavalue")).addClass("inp");
	        }
	    });
	}
	
	if (!placeholderSupport()) {
	    placeholder(".submitInfo_name");
	    placeholder(".submitInfo_phone");
	    placeholder(".submitInfo_address");
	    placeholder(".ipt");
	}
	
	window.smallImgIndex = 0;
	window.smallImgIncludeIndex = 0;
	
	$('.joinUs_hotelPic_slider li').click(function () {
	    smallImgIncludeIndex = $(this).index();
	    // 屏蔽酒店实拍点击
	    if (language == 'zh-CN' && smallImgIncludeIndex >= 6) {
	        return;
	    }
	    if ((language == 'KO' || language == 'TH' || language == 'YH') && smallImgIncludeIndex >= 4) {
	        return;
	    }
	    var classArr = ['swiper-floral', 'swiper-vyluk', 'swiper-suoxing', 'swiper-arula', 'swiper-baina', 'swiper-banlan', 'swiper-beu'];
	    var thunmClassArr = ['.joinUs_hotelPic_thumb_floral', '.joinUs_hotelPic_thumb_vyluk', '.joinUs_hotelPic_thumb_suoxing', '.joinUs_hotelPic_thumb_arula', '.joinUs_hotelPic_thumb_baina', '.joinUs_hotelPic_thumb_banlan', '.joinUs_hotelPic_thumb_beu'];
	    $('.swiper-wrapper').attr('class', 'swiper-wrapper ' + classArr[smallImgIncludeIndex]);
	    $('.joinUs_hotelPic_thumb ul').hide();
	    $(thunmClassArr[smallImgIncludeIndex]).show();
	    $(this).addClass('current').siblings().removeClass('current');
	    smallImgIndex = 0;
	    mySwiper.slideTo(smallImgIndex + 1, 500);
	    mySwiper.autoplay.start();
	    $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select');
	});
	
	$('.joinUs_hotelPic_thumb li').on('click', function () {
	    smallImgIndex = $(this).index();
	    mySwiper.slideTo(smallImgIndex + 1, 500);
	    mySwiper.autoplay.start();
	    $(this).find('span').addClass('select');
	    $(this).siblings().find('span').removeClass('select');
	});
	$('.joinUs_hotelPic_thumb li').mouseover(function () {
	    $(this).css({ transform: 'translateY(-10px)', padding: '0 0 10px 0' });
	    $(this).find('span').addClass('select');
	    $(this).siblings().find('span').removeClass('select');
	}).mouseout(function () {
	    $(this).css({ transform: 'translateY(0px)', padding: '0 0 0px 0' });
	    $(this).find('span').removeClass('select');
	    $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select');
	});
	
	var mySwiper = new Swiper('.swiper-container', {
	    autoplay: {
	        delay: 3000
	    },
	    speed: 1000,
	    // autoplayDisableOnInteraction : false,
	    paginationClickable: true,
	    disableOnInteraction: false,
	    loop: true, // 循环模式选项
	    // 如果需要前进后退按钮
	    navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev'
	    },
	    on: {
	        slideChange: function () {
	            $('.joinUs_hotelPic_thumb li').find('span').removeClass('select');
	            smallImgIndex = this.activeIndex - 1;
	            if (this.activeIndex == 6) {
	                smallImgIndex = 0;
	            }
	            $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select');
	        }
	    }
	});
	
	function GetQueryString(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) return unescape(r[2]);return null;
	}

/***/ },

/***/ 218:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	if (language == 'USA') {
	    $('.joinrz').css('margin-top', '4px');
	    $('.joinrz').css('font-size', '18px');
	}
	if (language == 'zh-CN') {
	    document.getElementsByTagName('meta')[1].setAttribute('content', franchmeta[language]);
	    document.getElementsByTagName('meta')[2].setAttribute('content', franchkey[language]);
	    document.title = franchtitle[language];
	} else {
	    document.getElementsByTagName('meta')[1].setAttribute('content', franchmeta['USA']);
	    document.getElementsByTagName('meta')[2].setAttribute('content', franchkey['USA']);
	    document.title = franchtitle['USA'];
	    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
	}
	$('.commonlanguage').html(commonlanguage[language]);
	$('title').html(joinUsTitle[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonJtc').html(commonJtc[language]);
	$('.commonJtcDes').html(commonJtcDes[language]);
	$('.commonBainaDes').html(commonBainaDes[language]);
	$('.commonBanlanDes').html(commonBanlanDes[language]);
	
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	// $('.commonPaidInformation').html(commonPaidInformation[language]);
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	
	$('.wzJoin').html(wzJoin[language]);
	$('.wzTelephone').html(wzTelephone[language]);
	
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.joinUsDreamofgoldnuggets').html(joinUsDreamofgoldnuggets[language]);
	$('.homePageSwiperFiveJointheInformation').html(homePageSwiperFiveJointheInformation[language]);
	$('.homePageSwiperFiveGirl').html(homePageSwiperFiveGirl[language]);
	$('.homePageSwiperFiveBoy').html(homePageSwiperFiveBoy[language]);
	$('.homePageSwiperFiveInputPhone').attr('placeholder', joinUsInputPhone[language]);
	$('.homePageSwiperFiveInputPhone').attr('datavalue', joinUsInputPhone[language]);
	$('.homePageSwiperFiveInputAddress').attr('placeholder', joinUsInputAddress[language]);
	$('.homePageSwiperFiveInputAddress').attr('datavalue', joinUsInputAddress[language]);
	$('.homePageSwiperFiveInputSpace').attr('placeholder', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveInputSpace').attr('datavalue', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveJoin').html(homePageSwiperFiveJoin[language]);
	$('.homePageSwiperFiveMaterialcooperation').html(homePageSwiperFiveMaterialcooperation[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('placeholder', joinUsInputRemarkTip[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', joinUsInputRemarkTip[language]);
	$('.homePageSwiperFiveInputName').attr('placeholder', joinUsInputName[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', joinUsInputRemarkTip[language]);
	$('.homePageSwiperFiveInputName').html(joinUsInputName[language]);
	$('.homePageSwiperFiveJoinLvyue').html(joinUsConsultation[language]);
	$('.homePageSwiperFiveJoinInfo').html(joinUsConsultationWrap[language]);
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.subhtml').html(subhtml[language]);
	
	$('.joinTitle').html(joinTitle[language]);
	$('.joinContent').html(joinContent[language]);
	$('.joinTitle22').html(joinTitle22[language]);
	$('.joinContent22').html(joinContent22[language]);
	$('.joinTitle33').html(joinTitle33[language]);
	$('.joinContent33').html(joinContent33[language]);
	$('.joinTitle44').html(joinTitle44[language]);
	$('.joinContent44').html(joinContent44[language]);
	$('.joinTitle55').html(joinTitle55[language]);
	$('.joinContent55').html(joinContent55[language]);
	
	$('.joinUsInputNameTitle').html(joinUsInputNameTitle[language]);
	$('.joinUsInputPhoneTitle').html(joinUsInputPhoneTitle[language]);
	$('.joinUsInputAddressTitle').html(joinUsInputAddressTitle[language]);
	$('.joinUsInputRemarkTipTitle').html(joinUsInputRemarkTipTitle[language]);
	$('.joinUsJoinTelephone').html(joinUsJoinTelephone[language]);
	
	$('.intenails').html(intenails[language]);
	$('.dobuemai').html(dobuemai[language]);
	
	$('.joinUsInputJoinMsg').html(joinUsInputJoinMsg[language]);
	$('.joinUsStep').html(joinUsStep[language]);
	$('.joinUsHonor2019Title').html(joinUsHonor2019Title[language]);
	$('.joinUsHonor2018Title').html(joinUsHonor2018Title[language]);
	$('.joinUsHonor2017Title').html(joinUsHonor2017Title[language]);
	$('.joinUsTel').html(joinUsTel[language]);
	$('.freePhone').html(freePhone[language]);
	$('.joinrz').html(joinrz[language]);
	$('.joinUsHonor201901').html(joinUsHonor201901[language]);
	$('.joinUsHonor201902').html(joinUsHonor201902[language]);
	$('.joinUsHonor201903').html(joinUsHonor201903[language]);
	$('.joinUsHonor201801').html(joinUsHonor201801[language]);
	$('.joinUsHonor201802').html(joinUsHonor201802[language]);
	$('.joinUsHonor201701').html(joinUsHonor201701[language]);
	$('.joinUsHonorTitle').html(joinUsHonorTitle[language]);
	
	$('.joinUsHonorTitle').html(joinUsHonorTitle[language]);
	$('.flowerBuildingaboutfbType1').html(joinUs_brandDescFloral[language]);
	$('.commonVylukDes').html(joinUs_brandDescVyluk[language]);
	$('.commonVyluk').html(commonVyluk[language]);
	$('.commonSuoxingDes').html(joinUs_brandDescSuoxing[language]);
	$('.commonRealShot').html(commonRealShot[language]);
	$('.franchiseAdvantage').html(franchiseAdvantage[language]);
	$('.joinUs_brandTitle').html(joinUs_brandTitle[language]);
	$('.joinUsIntroduce1').html(joinUsIntroduce1[language]);
	$('.joinUsIntroduce2').html(joinUsIntroduce2[language]);
	$('.joinUsIntroduce3').html(joinUsIntroduce3[language]);
	$('.joinUsCommonWantUs').html(joinUsCommonWantUs[language]);
	$('.joinUsDescribe').html(joinUsDescribe[language]);
	$('.joinUsTitleH1').html(joinUsTitleH1[language]);
	$('.joinUs_ad1Title').html(joinUs_ad1Title[language]);
	$('.joinUs_ad1Des').html(joinUs_ad1Des[language]);
	$('.joinUs_ad2Title').html(joinUs_ad2Title[language]);
	$('.joinUs_ad2Des').html(joinUs_ad2Des[language]);
	$('.joinUs_ad3Title').html(joinUs_ad3Title[language]);
	$('.joinUs_ad3Des').html(joinUs_ad3Des[language]);
	$('.joinUs_ad4Title').html(joinUs_ad4Title[language]);
	$('.joinUs_ad4Des').html(joinUs_ad4Des[language]);
	$('.joinUs_ad5Title').html(joinUs_ad5Title[language]);
	$('.joinUs_ad5Des').html(joinUs_ad5Des[language]);
	$('.joinUs_ad6Title').html(joinUs_ad6Title[language]);
	$('.joinUs_ad6Des').html(joinUs_ad6Des[language]);
	$('.joinUs_ad7Title').html(joinUs_ad7Title[language]);
	$('.joinUs_ad7Des').html(joinUs_ad7Des[language]);
	$('.joinUs_ad8Title').html(joinUs_ad8Title[language]);
	$('.joinUs_ad8Des').html(joinUs_ad8Des[language]);
	$('.joinUs_disclaimer').html(joinUs_disclaimer[language]);
	$('.floralReservation').html(floralReservation[language]);
	$('.commonBaina').html(commonBaina[language]);
	$('.commonBanlan').html(commonBanlan[language]);
	$('.commonBeuDes').html(commonBeuDes[language]);

/***/ },

/***/ 241:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/hanyuMap.png?v=c190eaa7";

/***/ },

/***/ 242:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/riyuMap.png?v=ed9af0c3";

/***/ },

/***/ 243:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/taiyuMap.png?v=50998259";

/***/ },

/***/ 244:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/yueyuMap.png?v=a8148cfd";

/***/ }

});


/** WEBPACK FOOTER **
 ** js/joinUS.94cf8b3f.js
 **/